import { render, staticRenderFns } from "./MajorScenarios.vue?vue&type=template&id=53057a5e&"
import script from "./MajorScenarios.vue?vue&type=script&lang=js&"
export * from "./MajorScenarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports